import { CSSProperties } from "react";
import { Link } from "react-router";

interface HelpButtonProps {
  style?: CSSProperties;
  tab?: string;
}

/**
 * Links to the SK Help Page
 */
export function HelpButton(props: HelpButtonProps) {
  return (
    <Link
      className="link"
      to="/sk/help"
      state={{
        helpItem: props.tab,
      }}
      style={{ ...props.style, fontSize: 24 } as CSSProperties}
      onClick={() => window.scrollTo(0, 0)}
      aria-label="Scorekeeper Help"
    >
      ?
    </Link>
  );
}
